import { render, staticRenderFns } from "./Olympics.vue?vue&type=template&id=a5703c4a&"
import script from "./Olympics.vue?vue&type=script&lang=js&"
export * from "./Olympics.vue?vue&type=script&lang=js&"
import style0 from "./Olympics.vue?vue&type=style&index=0&id=a5703c4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports